
import { Component, Mixins, Prop } from "vue-property-decorator";
import DashboardMixin from "@/views/dashboard/dashboard.mixin";
import moment from "moment";

@Component
export default class BiometricResult extends Mixins(DashboardMixin) {
  @Prop() biometricResultShow!: boolean;
  @Prop() selectedDate!: string;

  date = moment();
  loading = false;

  get formattedDate() {
    if (this.date && this.date.isValid && this.date.isValid()) {
      return this.date.format("M/DD");
    }
    return "";
  }

  async mounted() {
    this.loading = true;
    this.date = moment(this.selectedDate, 'M/DD');
    await this.fetchData();
    this.loading = false;
  }

  async moveTime(forward: boolean) {
    this.loading = true;
    this.date = moment(this.date)
      [forward ? "add" : "subtract"](1, "days")
    await this.fetchData();
    this.loading = false;
  }

  async fetchData() {
    await this.$store.dispatch("Dashboard/fetchBiometricResultsForDay", {
      date: this.formattedDate,
      participantId: this.selectedPatientSummary.participantId, 
      clientId: this.selectedClientDDL.value,
      timezone: this.selectedClient.timezone
    });
  }

  createLabels() {
    const labels: string[][] = [];
    for (let hour = 0; hour < 24; hour++) {
      const time = moment({ hour }).format('h:mm');
      const period = hour < 12 ? 'AM' : 'PM';
      labels.push([time, period]);
    }
    return labels;
  }

  getCellClass(metric: string, value?: number): string {
    if (metric !== 'minutesPerHour' || value == null) return '';
    if (value === 60) return 'asleep-cell';
    if (value >= 0 && value < 60) return 'partial-cell';
    return '';
  }

  closeModal() {
    this.$emit('update:biometricResultShow', false);
  }
}
